var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionPaymentEntryInfo } from "./actionPaymentEntryInfo";
var initial = {
    purchasedPackages: new Map(),
};
export var reducerPaymentEntryInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPaymentEntryInfo.SetPaymentEntryInfo: {
            if (action.offers !== undefined) {
                var purchasedPackages_1 = state.purchasedPackages;
                action.offers.forEach(function (offer) {
                    if (offer.typeId && purchasedPackages_1.has(offer.typeId)) {
                        if (purchasedPackages_1.has(offer.typeId)) {
                            purchasedPackages_1.delete(offer.typeId);
                            purchasedPackages_1.set(offer.typeId, offer);
                        }
                    }
                    else if (offer.typeId) {
                        purchasedPackages_1.set(offer.typeId, offer);
                    }
                });
                return {
                    purchasedPackages: purchasedPackages_1,
                };
            }
            return __assign({}, state);
        }
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/payment-entry-info/reducerPaymentEntryInfo.ts
// module id = 2537
// module chunks = 3